import { queryOptions } from "@tanstack/react-query";
import * as profilesApi from "./profiles-api";

export const profileQueries = {
  all: () => ["profiles"] as const,
  details: () => [...profileQueries.all(), "detail"] as const,
  byUser: (userId: string) =>
    queryOptions({
      queryKey: [...profileQueries.details(), userId],
      queryFn: () => profilesApi.getProfile(userId),
    }),
  subscriptions: () => [...profileQueries.all(), "subscription"] as const,
  subscription: (userId: string) =>
    queryOptions({
      queryKey: [...profileQueries.subscriptions(), userId],
      queryFn: () => null, // Subscriptions don't fetch data
    }),
};
